import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: 'input[type=text][appSmartCase]'
})
export class SmartCaseDirective {
  private changed = false;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event']) onInput(event: Event) {
    const input = this.el.nativeElement;

    if (!this.changed) {
      this.changed = true;
    }

    const newValue = this.changed ? input.value.toLowerCase() : input.value;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    input.value = newValue;
    input.setSelectionRange(start, end);
    //input.dispatchEvent(new Event('input'));
  }
}
